import React from 'react'

const formatBytes = (bytes, decimals) => {
  if (!bytes) {
    return 'N/A'
  }
  if (bytes == 0) {
    return '0 Bytes'
  }

  let k = 1024,
    dm = decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

const File = ({ url, title, name, size, type, lastModified, path, fileSize, onDelete, uploading = false }) => {
  const onClick = (event) => {
    event.stopPropagation()

    if (onDelete) {
      onDelete()
    }
  }

  return (
    <div className="bg-white border border-gray p-2 flex justify-between items-center cursor-default">
      <a href={url || path} target="_blank" className="truncate font-mono font-medium">
        <div className="text-sm text-primary truncate">{title || name || 'Untitled'}</div>
        <div className="text-xs text-gray-500">{formatBytes(fileSize || size)}</div>
      </a>

      {uploading && (
        <i className="ml-3 fa fa-fal fa-sync text-gray-500 animate-spin" />
      )}

      {onDelete && (
        <i
          className="ml-3 fa fa-fal fa-trash cursor-pointer text-gray-500 hover:text-gray-700"
          onClick={onClick}
        />
      )}
    </div>
  )
}

export default File
